import { Component, DestroyRef, inject, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActionWithMoreInfoModel } from '@bo-client/activation-management/shared/models/actionWithMoreInfo.model';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { distinctUntilChanged, map, take } from 'rxjs/operators';

@Component({
  selector: 'app-confirm-comment-modal',
  templateUrl: './confim-with-comment-modal.component.html',
  styleUrls: ['./confim-with-comment-modal.component.scss']
})
export class ConfimWithCommentModalComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly destroyRef = inject(DestroyRef);

  public comment = '';
  public commentRequested: string = null;
  public subject = '';
  public actionName = '';
  public recipients = '';
  hideCommentField = false;
  dialogInfoText: string = null;

  constructor(
    public dialogRef: MatDialogRef<ConfimWithCommentModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ActionWithMoreInfoModel,
    protected toastService: ToastrService
  ) {}

  ngOnInit() {
    const additionalData = this.data.additionalData as {
      hideCommentField?: boolean;
      dialogInfoText?: string;
    };
    if (additionalData) {
      this.hideCommentField = additionalData.hideCommentField ?? false;
      this.dialogInfoText = additionalData.dialogInfoText ?? null;
    }
    this.actionName = this.data.actionName;
    this.recipients = this.data.recipients;
    this.subject = this.data.subject;
    this.commentRequested = this.data.commentRequested;

    if (!this.hideCommentField) {
      this.route.queryParamMap
        .pipe(
          takeUntilDestroyed(this.destroyRef),
          map((params) => params.get('action.comment')),
          distinctUntilChanged(),
          take(1)
        )
        .subscribe((comment) => {
          if (comment) {
            this.comment = comment;
            this.router.navigate([], {
              queryParams: {
                'action.comment': null
              },
              queryParamsHandling: 'merge'
            });
          }
        });
    }
  }

  cancel() {
    if (this.comment) {
      this.router
        .navigate([], {
          queryParams: {
            'action.comment': this.comment
          },
          queryParamsHandling: 'merge'
        })
        .finally(() => {
          this.dialogRef.close(false);
        });
    } else {
      this.dialogRef.close(false);
    }
  }

  confirm() {
    if (!this.comment && this.commentRequested) {
      this.toastService.error('Bitte begründen Sie diese Aktion');
      return;
    }
    this.data.subject = this.subject;
    this.data.comment = this.hideCommentField ? '(ohne Kommentar)' : this.comment;

    this.dialogRef.close(this.data);
  }
}
